module.exports = __webpack_public_path__ + "static/media/Accessibility-red.f2e32662.svg";